import React, { useState } from 'react';
// Material UI
import { makeStyles } from '@material-ui/core/styles';
import { Popover, Button, FormControlLabel, Checkbox, ButtonGroup, Grid } from '@material-ui/core';
// Project deps

type Props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
  onSelectAll: () => void,
  onDeselectAll: () => void,
  selected: { [key: string]: boolean },
  label?: string,
  data: string[],
}

const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: theme.spacing(1)
  },
  paper: {
    padding: theme.spacing(1),
  },
  control: {
    display: "block"
  }
}));

const numberOfItemsPerColumn = 6;

const GridSelector = (props: Props) => {
  const { onChange, onSelectAll, onDeselectAll, selected, label = "Open popover", data = [] } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<EventTarget & Element | null>(null);

  const handleClick = (event: React.SyntheticEvent) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const columns: number = parseInt((data.length / numberOfItemsPerColumn) + '') + 1;
  
  return (
    <React.Fragment>
      <Button aria-describedby={id} variant="contained" color="primary" onClick={handleClick} className={classes.button}>
        {label}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        classes={{ paper: classes.paper }}
      >
        <ButtonGroup fullWidth>
          <Button onClick={onSelectAll}>Select all</Button>
          <Button onClick={onDeselectAll}>Deselect all</Button>
        </ButtonGroup>
        <Grid container>
          {
            Array.apply(null, Array(columns)).map((_, index) => {
              return (
                <Grid item key={"container-"+index}>
                  {
                    data
                      .slice(index * numberOfItemsPerColumn, index * numberOfItemsPerColumn + numberOfItemsPerColumn)
                      .map(item => {
                        const isSelected: boolean = selected[item]
                        return (
                          <FormControlLabel
                            key={item}
                            className={classes.control}
                            control={
                              <Checkbox
                                checked={isSelected}
                                onChange={onChange}
                                name={item}
                                color="primary"
                              />
                            }
                            label={item}
                          />
                        )
                      })
                  }
                </Grid>
              )
            })
          }
        </Grid>
      </Popover>
    </React.Fragment>
  );
}

export default GridSelector;
